import { createPopup } from "../technical/popup-new";
import { expressQuerySelector } from "../../common/html";

export interface IUploadDialog {
	id: string;
	setTotalUploads?: (id: string, newTotal: number) => void;
	close: () => void;
	updateProgress: (currentFile: number, currentUploadId?: string, singleUploadFailed?: boolean) => void;
	getRemaining?: () => number;
}

export async function createUploadDialog(totalUploads: number): Promise<IUploadDialog> {
	const res = await createPopup({
		dialogId: "uploadProgress",
		view: "LoadingDialog",
		data: {
			TotalFiles: totalUploads,
		},
	});
	if (!res.popup) return;
	const progressEl = expressQuerySelector<HTMLElement>(res.popup, ".technical-progress", true);
	const progressMessage = progressEl.dataset.text || "";
	const updateProgress = (currentFile_1: number) => {
		progressEl.innerText = progressMessage.replace("{0}", currentFile_1 + "").replace("{1}", totalUploads + "");
	};
	await res.openAsync();
	return {
		close: res.close,
		updateProgress,
	} as IUploadDialog;
}
